import type { ScreenModule } from "../../../app/screen-module";
import { ProjectListPage } from "../WorkspacePages";

export default {
	id: "end-user.projects",
	path: "/app/projects",
	area: "end-user",
	navGroup: "はたらく",
	label: "プロジェクト",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ProjectListPage,
} satisfies ScreenModule;
